module.exports = __webpack_public_path__ + "img/profile-min.ee845a29.png";